import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import BackToTop from '@elem/compCommon/BackToTop';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import E_NA from './components/E_NA';
import EU from './components/EU';
import E_GS from './components/E_GS';
import F_GS from './components/F_GS';
import F from './components/F';
import F_NA from './components/F_NA';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
// import N from './components/N';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';
import JoinUs from './components/JoinUs';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import G2 from './components/G2';
import H2 from './components/H2';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('vanliferoadtrips');
    const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const [updateSolar, setUpdateSolar] = useState(null);
    const IS_NA: boolean = ['us', 'ca'].includes(locale);
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_RW: boolean = ['au', 'za', 'kr'].includes(locale);

    const obj: SideMenuProps = EU_SITES.includes(locale)
        ? {
            items: [
                { text: t('secC_btn1'), link: '#vanlife-roadtrips-D' },
                { text: t('secC_btn2'), link: '#vanlife-roadtrips-G' },
                { text: t('secC_btn4'), link: '#vanlife-roadtrips-L' },
                ...(['eu', 'uk', 'de', 'fr'].includes(locale) ? [{ text: t('secC_btn5'), link: '#vanlife-roadtrips-G2' }] : []),
                { text: t('secC_btn3'), link: '#vanlife-roadtrips-J' },
            ],
        }
        : {
            items: [
                { text: t('secC_btn1'), link: '#vanlife-roadtrips-D' },
                { text: t('secC_btn2'), link: '#vanlife-roadtrips-G' },
                { text: t('secC_btn3'), link: '#vanlife-roadtrips-J' },
                { text: t('secC_btn4'), link: '#vanlife-roadtrips-L' },
            ],
        };
    const getDynamicLinkBuy = (item): string => {
        let link = `https://${locale}.ecoflow.com/cart/`;
        if (item && item?.length > 0) {
            item?.map((sub, index) => {
                link += `${index === 0 ? '' : ','}${sub?.variantId}:${sub?.quantity || 1}`;
            });
        }
        link += `?channel=buy_button`;
        return link;
    };
    const handleAddCart = (data: any, isLink?: boolean) => {
        const cards = Array.isArray(data) ? data : [data];
        let result = JSON.parse(JSON.stringify(shoppingCarts));
        cards?.map((card: ShopifyCartItemType) => {
            const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
            if (card?.parentVariantId) {
                const target = result.find(
                    (item: ShopifyCartItemType) =>
                        item?.productId === card?.productId && item?.variantId === card?.variantId && item?.parentVariantId === card?.parentVariantId,
                );
                // 附属产品
                obj.quantity = Number(obj?.inventory) > 0 ? obj.quantity : 0;
                result = result.filter((item: ShopifyCartItemType) => !(item?.parentVariantId === card?.parentVariantId));
                if (target) {
                    result = [
                        obj,
                        ...result?.filter((item: any) => !(item?.variantId === target?.variantId && item?.parentVariantId === item?.parentVariantId)),
                    ];
                } else {
                    result = [obj, ...result];
                }
            } else {
                // 主产品
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    obj.quantity = target.quantity;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            }
        });
        if (isLink) {
            const link = getDynamicLinkBuy(cards)
            window.open(link, '_blank')
            return
        }
        setShoppingCarts(result);
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: string) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
        if (target) {
            setUpdateSolar(target);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C tags={obj.items} />
            <D />
            {IS_NA && <E_NA callBuy={handleAddCart} updateSolar={updateSolar} />}
            {(IS_EU || IS_RW) && <E_GS callBuy={handleAddCart} updateSolar={updateSolar} />}
            {!IS_NA && !IS_EU && !IS_RW && <E callBuy={handleAddCart} />}
            {IS_NA && <ProductInlineBanner />}
            {IS_NA && <F_NA callBuy={handleAddCart} updateSolar={updateSolar} />}
            {(IS_EU || IS_RW) && <F_GS callBuy={handleAddCart} updateSolar={updateSolar} />}
            {!IS_NA && !IS_EU && !IS_RW && <F callBuy={handleAddCart} />}
            <G />
            <H callBuy={handleAddCart} />
            {!EU_SITES.includes(locale) && (
                <>
                    <J />
                    <K />
                </>
            )}
            <L />
            <M callBuy={handleAddCart} />

            {['eu', 'uk', 'de', 'fr'].includes(locale) && (
                <>
                    <G2 />
                    <H2 callBuy={handleAddCart} />
                </>
            )}
            {EU_SITES.includes(locale) && (
                <>
                    <J />
                    <K />
                </>
            )}
            {/* shopify暂无该商品，隐藏 */}
            {/* <N callBuy={handleAddCart} /> */}
            {['au'].includes(locale) && <JoinUs />}
            {!['eu', 'uk', 'it', 'es', 'kr'].includes(locale) && <O />}
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.RoadTrips} entry_position={13} />
            <P />
            {!['eu', 'kr'].includes(locale) && <Q />}
            <R />
            <div className="annotation">
                <p className="title">{t('secS_title')}</p>
                {t('secS')}
            </div>
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.body)}
        </>
    );
}
